export const HEADERS_FOR_DISPLAY_FP_ACTIVE_TABLE = [
  'Period',
  'Total companies',
  'Investment',
  'Value',
  'Gain/(loss)',
  'MOIC',
  'IRR',
  null,

  'Companies',
  'Investment',
  'Value',
  'Unrealized gain/(loss) (w escr. & earn-out)',
  'MOIC',
  'Escrow companies',
  'Escrow/earnout',
  'IRR',
  null,

  'Companies',
  'Investment',
  'Value',
  'Realized gain/(loss)',
  'MOIC',
  'IRR',
];

export const HEADERS_FOR_LOGIC_FP_ACTIVE_TABLE = [
  'Period',
  'Total companies',
  'Investment',
  'Value',
  'Gain/(loss)',
  'MOIC',
  'IRR',
  'empty(0)',

  'Companies(1)',
  'Investment(1)',
  'Value(1)',
  'Unrealized gain/(loss) (w escr. & earn-out)',
  'MOIC(1)',
  'Escrow companies',
  'Escrow/earnout',
  'IRR(1)',
  'empty(1)',

  'Companies(2)',
  'Investment(2)',
  'Value(2)',
  'Realized gain/(loss)',
  'MOIC(2)',
  'IRR(2)',
];

export const FIRST_ROW_FP_ACTIVE_TABLE = [
  '', 'Total portfolio', '', '', '', '', '', null,
  '', 'Active portfolio', '', '', '', '', '', '', null,
  '', 'Sold portfolio', '', '', '', '', null,
];
